<div khA11yDialog>
<button khA11yActionButton class="kh-modal-close-button close-modal-icon" (click)="closeModal()" [khA11yLabel]="'A11Y_LABEL.CLOSE' | translate">
    <fa-icon khA11yHidden [icon]="['fas','times']"></fa-icon>
</button>

<div class="email-notifications-modal-container">
    <div khA11yLabelSource class="kh-heading-md-fluid mb-kh-4 heading">
        {{ 'EMAIL_NOTIFICATIONS_MODAL.EMAIL_NOTIFICATIONS' | translate }}
    </div>
    <form [formGroup]="emailGroupsForm" class="w-100">
        <div class="toggleOptionsContainer">
            <ng-container *ngFor="let groupName of getControlNames(); let i = index">
                <kh-divider class="w-100" *ngIf="i !== 0"></kh-divider>
                <div class="toggleOptionRow" [formGroupName]="groupName" khA11ySwitch>
                    <div class="toggleOptionDescription">
                        <label class="title" khA11yLabelSource>{{getControlValue(groupName, "Name")}}</label>
                        <label class="description" khA11yDescriptionSource>
                            {{getControlValue(groupName, "Description")}}
                        </label>
                    </div>
                    <div class="toggleOptionsSwitch">
                        <div class="switchContainer">
                        <label class="switch">
                            <input type="checkbox" formControlName="Control" [khA11ySwitch]="getControlValue(groupName, 'Control')">
                            <span class="track"></span>
                        </label>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </form>
    <div class="buttons-container">
        <button class="kh-tertiary-button kh-title-text" (click)="closeModal()">{{ 'EMAIL_NOTIFICATIONS_MODAL.CANCEL' | translate }}</button>
        <div class="d-block w-kh-2"></div>
        <button class="kh-primary-button kh-title-text" (click)="onSave()">{{ 'EMAIL_NOTIFICATIONS_MODAL.SAVE_CHANGES' | translate }}</button>
    </div>
</div>
</div>
